import { isEmpty, get } from 'lodash';
import moment from 'moment';
import store from '../store/store';
import ReactHtmlParser from 'html-react-parser';

export * from './AUMessageCatalog';
export * from './VacationMessageCatalog';
export * from './TripsMessageCatalog';

export const getTranslatedMessage = (
  groupofMessageContent, messageGroupId, messageId, defaultMessage,
) => {
  // for local environment default message will never be displayed.
  const hardCodedMCValue = process.env.NODE_ENV === 'development' ? '' : defaultMessage;
  if (groupofMessageContent && messageGroupId && groupofMessageContent[messageGroupId]
      && !isEmpty(groupofMessageContent[messageGroupId])) {
    const messageDetails = groupofMessageContent[messageGroupId][`${messageId}`];
    return typeof messageDetails === 'object' ? messageDetails.translatedMessage : hardCodedMCValue;
  }
  return hardCodedMCValue;
  // return defaultMessage;
};


export const currencyFormatter = new Intl.NumberFormat('en-US', {
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const durationJson = (data, seletedVal, days, day) => {
  if (data && data.length > 0) {
    const durationarray = data.map(
      val => ({
        name: val === 1 ? `${val} ${day}` : `${val}  ${days}`,
        isSelected: parseInt(seletedVal, 10) === parseInt(val, 10),
        key: val,
      }),
    );
    return durationarray;
  }
  return false;
};

export const getCookie = (cName) => {
  const name = cName + "=";
  const cDecoded = decodeURIComponent(document.cookie); //to be careful
  const cArr = cDecoded.split('; ');
  let res = false;
  cArr.forEach(val => {
    if (val.indexOf(name) === 0) res = val.substring(name.length);
  })
  return res;
};

// export const formatDateForMonthYear = (datestring, isYearRequired = true) => {
//   // const parsedDate = Date.parse(`${datestring}T00:00:00.000+00:00`);
//   const parsedDate = moment(datestring);
//   const date = new Date(parsedDate);
//   const months = store.getState().CommonReducer.translatedMonths;
//   console.log('months', months, );
//   if (!Number.isNaN(parsedDate)) {
//     return `${months[date.getMonth()]} ${
//       isYearRequired ? date.getFullYear() : ''
//     }`;
//   }
//   return datestring;
// };

export const getAUQueryParams = (search) => {
  const urlParams = new URLSearchParams(search);
  const resortId = urlParams.get('resortId') ? decodeURIComponent(urlParams.get('resortId')).trim() : null;
  const productType = urlParams.get('productType');
  const losXmlId = urlParams.get('losXmlId');
  const unitXmlId = urlParams.get('unitXmlId');
  const minStartDate = urlParams.get('minStartDate');
  const rciExpress = urlParams.get('rciExpress');
  const isMonth = urlParams.get('isMonth') === 'true';
  const deals = urlParams.get('deals') === 'true';
  const expiringPoint = urlParams.get('expiringPoint') === 'true';
  const maxStartDate = urlParams.get('maxStartDate');
  const navFrom = urlParams.get('navFrom');
  const offerId = urlParams.get('offerId');
  const list = urlParams.get('list');
  const mapView = urlParams.get('mapView');
  const position = urlParams.get('position');
  const sleepsId = urlParams.get('sleepsId');
  const priceId = urlParams.get('priceId');
  const favSearchId = urlParams.get('favSearchId');
  const isDateRange = urlParams.get('isDateRange');
  const weeksRangexmlid = urlParams.get('weeksRangexmlid');
  const priorityAccessXmlId = urlParams.get('priorityAccessXmlId');
  const homeGroup = urlParams.get('homegroup') === 'true';
  const homeResort = urlParams.get('homeresort') === 'true';
  const isHomeResDateRange = urlParams.get('isHomeResDateRange') === 'true';
  const errorCode = urlParams.get('errorCode');
  const isExchangePlus = urlParams.get('isExchangePlus')=== 'true';
  const isRentalPlus = urlParams.get('isRentalPlus')=== 'true';
  const cid = urlParams.get('cid');
  const selDepositId = urlParams.get('selDepositId');
  const offerPreview = urlParams.get('offerPreview');
  return {
    resortId,
    productType,
    losXmlId,
    unitXmlId,
    minStartDate,
    maxStartDate,
    rciExpress,
    isMonth,
    deals,
    expiringPoint,
    navFrom,
    offerId,
    list,
    mapView,
    position,
    sleepsId,
    priceId,
    favSearchId,
    isDateRange,
    weeksRangexmlid,
    priorityAccessXmlId,
    homeGroup,
    homeResort,
    isHomeResDateRange,
    isExchangePlus,
    isRentalPlus,
    cid,
    selDepositId,
    offerPreview,
  };
};


export const getCapitalizeProductType = (productType) => {
  switch (productType && productType.toLowerCase()) {
    case 'exchange':
      return 'Exchange';
    case 'extravacation':
      return 'ExtraVacation';
    case 'lastcall':
      return 'LastCall';     
    default:
      return 'All';
  }
};

export const getDaysInMonth = (month, year) => {
  const date = new Date(year, month, 1);
  const days = [];
  while (date.getMonth() === month) {
    days.push(new Date(date));
    date.setDate(date.getDate() + 1);
  }
  return days;
};

export const getEligibility = (Key) => {
  const eligibility = store.getState().CommonReducer.customerProfile.eligibleFeatures;
  // const eligibility = JSON.parse(localStorage.getItem(ELEGIBILITY_COOKIE_STORE));
  if (eligibility) {
    return get(eligibility, Key);
  }
  return false;
};

export const getRestOfElementsBetweenTwoArray = (firstArrayDate, secondArrayDate) => {
  const restOfTheElements = [];
  let restArray = [];
  const firstArrayDateCustomize = firstArrayDate.map(each => moment(each).format('MM/DD/YYYY'));
  const secondArrayCustomize = secondArrayDate.map(each => moment(each).format('MM/DD/YYYY'));
  for (let i = 0; i < firstArrayDateCustomize.length; i += 1) {
    if (secondArrayCustomize.indexOf(firstArrayDateCustomize[i]) === -1) {
      restOfTheElements.push(firstArrayDateCustomize[i]);
    }
  }
  restArray = restOfTheElements.map(each => new Date(each));
  return restArray;
};


export const numberFormatter = (value) => {
  const formatter = new Intl.NumberFormat();
  return formatter.format(value);
};

export const serviceResponseIntegrateWithMessageCatalog = (
  messageCatalogString,
  replacableKeysArray,
  replaceableValue,
) => {
  // const regexTemplate = new RegExp(/^(@@)/g);
  // const messageCatalogArray = messageCatalogString.split(' ');
  // const updateMessageCatalogArray = messageCatalogArray.map((eachWord) => {
  //   if (regexTemplate.test(eachWord)) {
  //     const indentifyKey = eachWord.substr(2);
  //     return replaceableValue[indentifyKey] || indentifyKey;
  //   }
  //   return eachWord;
  // });
  let reponseIntegratedMessage = messageCatalogString;
  replacableKeysArray.forEach((replacableKey) => {
    const key = '@@'.concat(replacableKey);
    reponseIntegratedMessage = reponseIntegratedMessage.replace(
      key, replaceableValue[replacableKey],
    );
  });
  return reponseIntegratedMessage;
};

export const setWindowScolling = height => (window.scrollTo({
  top: window.scrollY - height,
  left: 0,
  behavior: 'smooth',
}));


export const momentLocalelize = (date) => {
  const code = 'EN';
  const messageContent = store.getState().CommonReducer.messageCatalog;
  moment.locale(code.toLowerCase(), {
    months: [getTranslatedMessage(messageContent, 'PWE_WOW_Common', 13, 'January'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 14, 'February'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 15, 'March'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 16, 'April'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 17, 'May'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 18, 'June'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 19, 'July'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 20, 'August'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 21, 'September'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 22, 'October'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 23, 'November'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 24, 'December')],
    monthsShort: [getTranslatedMessage(messageContent, 'PWE_WOW_Common', 25, 'Jan'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 26, 'Feb'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 27, 'Mar'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 28, 'Apr'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 29, 'May'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 30, 'Jun'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 31, 'Jul'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 32, 'Aug'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 33, 'Sep'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 34, 'Oct'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 35, 'Nov'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 36, 'Dec')],
    weekdays: [getTranslatedMessage(messageContent, 'PWE_WOW_Common', 37, 'Sunday'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 38, 'Monday'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 39, 'Tuesday'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 40, 'Wednesday'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 41, 'Thursday'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 42, 'Friday'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 43, 'Saturday'),
    ],
    weekdaysShort: [getTranslatedMessage(messageContent, 'PWE_WOW_Common', 44, 'Sun'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 45, 'Mon'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 46, 'Tue'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 47, 'Wed'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 48, 'Thu'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 49, 'Fri'),
      getTranslatedMessage(messageContent, 'PWE_WOW_Common', 50, 'Sat'),
    ],
  });
  return moment(date);
};

export const checkLargeImageAvailable = (resortImg, imgObj) => {
  const filterImageList = resortImg.filter((val => val.assetSize === 'X'));
  let lImage = '';
  let flag = false;
  filterImageList.length > 0 && filterImageList.forEach((item) => {
    lImage = item.imageName.substring(0, item.imageName.length - 5);
    if (lImage === imgObj.imageName.substring(0, imgObj.imageName.length - 5)) {
      flag = true;
    }
  });
  return flag;
};

export const AiFeeDate = (date) =>{

  const monthNumbertoLabelMap = {
    "01": 'Jan',
    "02": 'Feb',
    "03": 'Mar',
    "04": 'Apr',
    "05": 'May',
    "06": 'Jun',
    "07": 'Jul',
    "08": 'Aug',
    "09": 'Sep',
    "10": 'Oct',
    "11": 'Nov',
    "12": 'Dec',
  }
  let day = date.split("-")[0]
  let month = date.split("-")[1];
  let year = date.split("-")[2]
  month =  month.replace(month, monthNumbertoLabelMap[month]);
  const AIFeeDateFormatted = day+"-"+month+"-"+year;
  return AIFeeDateFormatted;
  }


  export const getActualProductType = (productType) => {
    switch (productType) {
      case 'Exchange':
        return 'Exchange';
      case 'ExtraVacation':
        return 'extravacation';
      case 'LastCall':
        return 'lastcall';
      default:
        return 'exchange-extravacation-lastcall';
    }
  };

  export const miawChatCheckLocale = (customerLocale) => {
    const { MIAW_CHAT_LOCALE } = window.weeksWebCloudConfig;
    return MIAW_CHAT_LOCALE && MIAW_CHAT_LOCALE.includes(customerLocale);
  }

  export const aiChatcheckLocale = (customerLocale) => {
  const { AI_CHAT_LOCALE } = window.weeksWebCloudConfig;
  return AI_CHAT_LOCALE && AI_CHAT_LOCALE.includes(customerLocale);
  };
  
  export const totalFeesCheckLocale = (customerLocale) => {
    const { TOTAL_FEES_LOCALE } = window.weeksWebCloudConfig;
    return TOTAL_FEES_LOCALE && TOTAL_FEES_LOCALE.includes(customerLocale);
  }

  export const totalFeesCheck = () => isSearchFeatureEnabled('RCIO_WKS_AU_TOTAL_FEE');


  export const isSearchFeatureEnabled = (cook) => {
  try {
    const cookieValue = getCookie(cook);
    
    // Check for truthy values (case-insensitive)
    if (cookieValue) {
      const normalizedValue = cookieValue.toLowerCase().trim();
      return normalizedValue === 'true';
    }
    
    return false;
  } catch (error) {
    console.error(`Error reading ${cook} cookie:`, error);
    return false; // Default to disabled if error reading cookie
  }
};

  export const safeHtmlParser = (content) => {
    return content && typeof content === 'string' ? ReactHtmlParser(content) : content;
  };